import { render, staticRenderFns } from "./JSelectNianJi.vue?vue&type=template&id=4785bf90&scoped=true"
import script from "./JSelectNianJi.vue?vue&type=script&lang=js"
export * from "./JSelectNianJi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4785bf90",
  null
  
)

export default component.exports